import svgUrl from "ni:svgr;amfC3CqoYVxYy4Ek7ZNsERUGSk_DDExU1IZuGq_3wIk";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const SvgChecked = props => <svg width={16} height={16} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" {...props}><path clipRule="evenodd" fill="currentColor" fillRule="evenodd" d="M12.48 4.424a.75.75 0 0 1 .096 1.056l-5 6a.75.75 0 0 1-1.106.05l-3-3a.75.75 0 0 1 1.06-1.06l2.42 2.419 4.474-5.37a.75.75 0 0 1 1.056-.095Z" /></svg>;
const Memo = memo(SvgChecked);
export { Memo as ReactComponent };